import { Box, Text } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export type ConfirmationPopupVariant = 'success' | 'error';

type Props = {
  label: string;
  variant?: ConfirmationPopupVariant;
};

export function ConfirmationPopup({ label, variant = 'success' }: Props) {
  const Icon = variant === 'error' ? IconX : IconCheck;

  return (
    <Box
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 32,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        paddingTop: 38,
        paddingBottom: 38,
        paddingLeft: 52,
        paddingRight: 52,
      }}
    >
      <Icon style={{ width: 83, height: 82 }} color="var(--mantine-color-gray-0)" />
      <Text mt={4} c="white" size="sm" fw={FONT_WEIGHTS.medium} ta="center">
        {label}
      </Text>
    </Box>
  );
}
